<tt-page>
    <tt-page-heading>{{ heading }}</tt-page-heading>
    <tt-checklist-data [params]="params" (settingsLoaded)="heading = $event.page_heading" (submit)="onSubmit()"></tt-checklist-data>
</tt-page>
